<template>
    <Prime-Badge
        v-if="frequencySetType"
        :value="frequencySetType.label"
        :size="size"
        :style="badgeStyle"
    />
</template>

<script>
import PrimeBadge from 'primevue/badge'
import { byValue as frequencySetTypeByValue } from '@/constants/frequency-set-types.js'

export default {
    components: { PrimeBadge },

    props: {
        type: {
            type: String,
            default: null,
        },
        size: {
            type: String,
            default: null,
        },
    },

    computed: {
        frequencySetType() {
            return (this.type ? frequencySetTypeByValue(this.type) : null) ?? null
        },

        badgeStyle() {
            if (!this.frequencySetType) {
                return null
            }

            return {
                backgroundColor: this.frequencySetType.backgroundColor,
                color: this.frequencySetType.textColor,
            }
        },
    },
}
</script>

<style scoped lang="scss">
.p-badge {
    user-select: none;
}
</style>
